import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TribesService } from 'src/app/services/tribes.service';
import { ForumModalComponent } from 'src/app/pages/forum-modal/forum-modal.component';
import { RowComponent } from './row/row.component';

@Component({
  selector: 'app-table-tribes',
  standalone: true,
  imports: [CommonModule,RowComponent],
  templateUrl: './table-tribes.component.html',
  styleUrls: ['./table-tribes.component.scss']
})
export class TableTribesComponent {

  constructor(private tribesService:TribesService) { }

  option: string = 'Todas las tribus';
  @ViewChild('modalComponent', { static: true }) modalComponent: ForumModalComponent | undefined;
  tribesList:any[] = []


  onClick(opt:string){
    this.option = opt;
  }
  ngOnInit(): void {
    // this.tribesService.getTribeById("27c2b896-16a9-43e8-8942-1ca94c6845ce").subscribe((c:any) => {
    //   this.tribesList = c.data;
    // });
  }

}
